define("shared/components/shared/mobile/drawer/feature-drawer", ["exports", "@ember/component", "@ember/object", "@ember/service", "@ember/template", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "later/utils/static-data/featurelink-content", "@ember/template-factory"], function (_exports, _component, _object, _service, _template, _utils, _component2, _tracking, _featurelinkContent, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _generatePlatformNoticeTranslation, _trackViewed;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/template",0,"@ember/utils",0,"@embroider/macros",0,"@glimmer/component",0,"@glimmer/tracking",0,"later/utils/static-data/featurelink-content",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.showFeatureDrawer}}
    <Shared::Mobile::Drawer::Layout
      @closeModal={{@closeModal}}
      @title={{this.title}}
      data-test-featurelink-type={{@featureName}}
    >
      <:body>
        {{#if this.feature.cards}}
          <Shared::Mobile::Drawer::CarouselCard
            @cards={{this.feature.cards}}
            @index={{this.currentCarouselIndex}}
            @seamlessCheckoutSuccessCallback={{@seamlessCheckoutSuccessCallback}}
            @triggerTrackWithInitialIndex={{this.triggerTrackWithInitialIndex}}
            @updateIndex={{this.updateIndex}}
          />
        {{else}}
          <Shared::Mobile::Drawer::ImageCard
            @image={{this.feature.image}}
            @imageAltText={{this.feature.title}}
            @showImageCss={{this.showImageCss}}
            @subtitle={{this.feature.subtitle}}
          />
        {{/if}}
      </:body>
      <:footer>
        {{#if this.feature.changePlatformText}}
          <p class="u--text--md u--m__t__sm">{{this.feature.changePlatformText}}</p>
        {{/if}}
        {{! Available Platform Banner }}
        {{#if this.shouldShowPlatformNotice}}
          <Shared::PlatformNotice
            @body={{this.platformNoticeBody}}
            @isAvailableOnDesktopAndMobile={{this.isAvailableOnDesktopAndMobile}}
            @title={{this.platformNoticeTitle}}
          />
        {{/if}}
        {{! Start Trial Button }}
        {{#if this.feature.needsUpgrade}}
          <Shared::Button::Upgrade
            @additional="block"
            @feature={{this.feature.featureUpgradeName}}
            @location={{this.upgradeButtonLocation}}
            @seamlessCheckoutSuccessCallback={{@seamlessCheckoutSuccessCallback}}
            @size="large"
            @variant="proceed"
            class="u--m__t"
          />
        {{else if this.isAvailableOnMobile}}
          {{! Open App Button  }}
          <Shared::Mobile::OpenApp
            @class="o-—btn o--btn--block o--btn--primary asdf u--m__t"
            data-test-featurelink-button="open-app"
            {{on "click" this.trackOpenApp}}
          >
            {{t "schedule.open_app"}}
            <span class="u--m__l__xs">{{svg-jar "android" class="o--icon o--icon--md" style="color: #78C257;"}}</span>
            <span class="u--m__l__xs">{{svg-jar "apple" class="o--icon o--icon--md" style="color: #555555;"}}</span>
          </Shared::Mobile::OpenApp>
        {{/if}}
      </:footer>
    </Shared::Mobile::Drawer::Layout>
  {{/if}}
  */
  {
    "id": "qI1pdY0m",
    "block": "[[[41,[30,0,[\"showFeatureDrawer\"]],[[[1,\"  \"],[8,[39,1],[[16,\"data-test-featurelink-type\",[30,1]]],[[\"@closeModal\",\"@title\"],[[30,2],[30,0,[\"title\"]]]],[[\"body\",\"footer\"],[[[[1,\"\\n\"],[41,[30,0,[\"feature\",\"cards\"]],[[[1,\"        \"],[8,[39,2],null,[[\"@cards\",\"@index\",\"@seamlessCheckoutSuccessCallback\",\"@triggerTrackWithInitialIndex\",\"@updateIndex\"],[[30,0,[\"feature\",\"cards\"]],[30,0,[\"currentCarouselIndex\"]],[30,3],[30,0,[\"triggerTrackWithInitialIndex\"]],[30,0,[\"updateIndex\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,3],null,[[\"@image\",\"@imageAltText\",\"@showImageCss\",\"@subtitle\"],[[30,0,[\"feature\",\"image\"]],[30,0,[\"feature\",\"title\"]],[30,0,[\"showImageCss\"]],[30,0,[\"feature\",\"subtitle\"]]]],null],[1,\"\\n\"]],[]]],[1,\"    \"]],[]],[[[1,\"\\n\"],[41,[30,0,[\"feature\",\"changePlatformText\"]],[[[1,\"        \"],[10,2],[14,0,\"u--text--md u--m__t__sm\"],[12],[1,[30,0,[\"feature\",\"changePlatformText\"]]],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"shouldShowPlatformNotice\"]],[[[1,\"        \"],[8,[39,4],null,[[\"@body\",\"@isAvailableOnDesktopAndMobile\",\"@title\"],[[30,0,[\"platformNoticeBody\"]],[30,0,[\"isAvailableOnDesktopAndMobile\"]],[30,0,[\"platformNoticeTitle\"]]]],null],[1,\"\\n\"]],[]],null],[41,[30,0,[\"feature\",\"needsUpgrade\"]],[[[1,\"        \"],[8,[39,5],[[24,0,\"u--m__t\"]],[[\"@additional\",\"@feature\",\"@location\",\"@seamlessCheckoutSuccessCallback\",\"@size\",\"@variant\"],[\"block\",[30,0,[\"feature\",\"featureUpgradeName\"]],[30,0,[\"upgradeButtonLocation\"]],[30,3],\"large\",\"proceed\"]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isAvailableOnMobile\"]],[[[1,\"        \"],[8,[39,6],[[24,\"data-test-featurelink-button\",\"open-app\"],[4,[38,7],[\"click\",[30,0,[\"trackOpenApp\"]]],null]],[[\"@class\"],[\"o-—btn o--btn--block o--btn--primary asdf u--m__t\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,8],[\"schedule.open_app\"],null]],[1,\"\\n          \"],[10,1],[14,0,\"u--m__l__xs\"],[12],[1,[28,[35,9],[\"android\"],[[\"class\",\"style\"],[\"o--icon o--icon--md\",\"color: #78C257;\"]]]],[13],[1,\"\\n          \"],[10,1],[14,0,\"u--m__l__xs\"],[12],[1,[28,[35,9],[\"apple\"],[[\"class\",\"style\"],[\"o--icon o--icon--md\",\"color: #555555;\"]]]],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[]],null]],[]]],[1,\"    \"]],[]]]]],[1,\"\\n\"]],[]],null]],[\"@featureName\",\"@closeModal\",\"@seamlessCheckoutSuccessCallback\"],false,[\"if\",\"shared/mobile/drawer/layout\",\"shared/mobile/drawer/carousel-card\",\"shared/mobile/drawer/image-card\",\"shared/platform-notice\",\"shared/button/upgrade\",\"shared/mobile/open-app\",\"on\",\"t\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/mobile/drawer/feature-drawer.hbs",
    "isStrictMode": false
  });
  let FeatureDrawerComponent = _exports.default = (_class = (_generatePlatformNoticeTranslation = /*#__PURE__*/new WeakSet(), _trackViewed = /*#__PURE__*/new WeakSet(), class FeatureDrawerComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _trackViewed);
      _classPrivateMethodInitSpec(this, _generatePlatformNoticeTranslation);
      _initializerDefineProperty(this, "segment", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "auth", _descriptor3, this);
      _initializerDefineProperty(this, "userAgent", _descriptor4, this);
      _defineProperty(this, "INITIAL_INDEX", 0);
      _initializerDefineProperty(this, "currentCarouselIndex", _descriptor5, this);
      _defineProperty(this, "viewedHistory", []);
    }
    get title() {
      return this.feature.cards ? this.feature.cards[this.currentCarouselIndex].title : this.feature.title;
    }
    get showFeatureDrawer() {
      return (0, _utils.isPresent)(this.feature) && (this.userAgent.device.isMobile || false);
    }
    get feature() {
      if (this.args.featureName) {
        return (0, _featurelinkContent.generateFeatureLinkObject)(this.args.featureName, this.intl, this.auth.currentAccount);
      }
      return this.args.featureObject;
    }
    get showImageCss() {
      return Boolean(this.feature.isFeaturelink && !this.feature.hideImageCss);
    }
    get isAvailableOnMobile() {
      return Boolean(this.feature?.platforms?.includes('mobile'));
    }
    get isAvailableOnDesktopAndMobile() {
      return Boolean(this.feature?.isFeaturelink && this.feature.platforms?.includes('mobile') && this.feature.platforms.includes('desktop'));
    }
    get isOnlyAvailableOnDesktop() {
      return Boolean(!this.feature?.platforms?.includes('mobile') && this.feature?.platforms?.includes('desktop'));
    }
    get platformNoticeBody() {
      return _classPrivateMethodGet(this, _generatePlatformNoticeTranslation, _generatePlatformNoticeTranslation2).call(this, 'shared_phrases.desktop_or_mobile_for_feature', 'shared_phrases.desktop_for_feature');
    }
    get platformNoticeTitle() {
      return _classPrivateMethodGet(this, _generatePlatformNoticeTranslation, _generatePlatformNoticeTranslation2).call(this, 'shared_phrases.desktop_and_mobile_available', 'shared_phrases.desktop_only');
    }
    get shouldShowPlatformNotice() {
      return this.isAvailableOnDesktopAndMobile || this.isOnlyAvailableOnDesktop;
    }
    get upgradeButtonLocation() {
      if (this.feature?.isFeaturelink) {
        return this.feature.name?.concat('_feature_link');
      }
      return this.feature?.name?.concat(' feature modal');
    }
    get subCardName() {
      return this.feature.cards?.[this.currentCarouselIndex].name;
    }
    get trackingLocation() {
      if (this.feature.isFeaturelink) {
        return `${this.feature.name}_feature_link`;
      }
      if (this.feature.cards) {
        return `${this.subCardName}_feature_card`;
      }
      return `${this.feature.name}_feature_card`;
    }
    updateIndex(index) {
      if (index !== this.currentCarouselIndex) {
        this.currentCarouselIndex = index;
      }
      _classPrivateMethodGet(this, _trackViewed, _trackViewed2).call(this);
    }
    trackOpenApp() {
      this.segment.track('clicked-later-app', {
        location: this.trackingLocation
      });
    }
    triggerTrackWithInitialIndex() {
      this.updateIndex(this.INITIAL_INDEX);
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userAgent", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "currentCarouselIndex", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return this.INITIAL_INDEX;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "updateIndex", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackOpenApp", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackOpenApp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triggerTrackWithInitialIndex", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "triggerTrackWithInitialIndex"), _class.prototype)), _class);
  function _generatePlatformNoticeTranslation2(desktopAndMobilePhrase, desktopPhrase) {
    return (0, _template.htmlSafe)(this.intl.t(this.isAvailableOnDesktopAndMobile ? desktopAndMobilePhrase : desktopPhrase));
  }
  function _trackViewed2() {
    if (!this.viewedHistory.includes(this.subCardName)) {
      this.viewedHistory.push(this.subCardName);
      this.segment.track('viewed-feature-card', {
        'feature-modal': 'scheduling',
        'feature-card': this.subCardName ?? ''
      });
    }
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FeatureDrawerComponent);
});